<div class="file-upload-wrapper">
      
      <input 
        #fileInput
        type="file" 
        [formlyAttributes]="field"
        (change)="onFileSelected($event)"
        accept="image/*"
        style="display: none;"
      >

      <div *ngIf="!fileName" class="upload-dropzone" (click)="openFileInput()">
        <i class="fa fa-cloud-upload"></i>
        <span>{{ to.placeholder || 'Clicca per caricare' }}</span>
      </div>

      <div *ngIf="fileName" class="file-selected-row">
        <span class="file-name">
          <i class="fa fa-file-o"></i> {{ fileName }}
        </span>
        <button type="button" class="remove-btn" (click)="removeFile()" title="Rimuovi">
          <i class="fa fa-times"></i>
        </button>
      </div>

</div>


// WEBPACK FOOTER //
// ./src/app/shared/components/schema-form/file-type-formly/file-type.component.html